<template>
    <div class="blog-aside">
      <a href="#">
        <aside>
          <img src="images/banners/banner-sidebar.jpg" alt="ad">
        </aside>
      </a>
      <div class="need-help">
          <h2 class="h4">هل تريد المساعده؟</h2>
          <p>يمكنك الاتصال بنا</p>
          <ul>
            <li>
              <a href="tel:0222616436">
                <i class="icon_set_1_icon-89"></i>
                0222616436
              </a>
            </li>
            <li>
              <a href="mailto:info@agazabook.com">
                <i class="icon_set_1_icon-84"></i>
                info@agazabook.com
              </a>
            </li>
          </ul>
      </div>
    </div>

</template>
<script type="text/javascript">

  export default {
    name:'AsideBlog',

  }
</script>
